import { gql } from "@apollo/client"

/**
 * Appointment mutations corresponding to REST /appointments endpoints.
 */

export const CREATE_APPOINTMENT = gql`
  mutation CreateAppointment($input: CreateAppointmentInput!) {
    createAppointment(input: $input) {
      id
      appointment_date
      appointment_time
      status
      isHomeService
      isPaymentComplete
      notes
      user {
        id
        email
      }
      service {
        id
        service_name
      }
      createdAt
      updatedAt
    }
  }
`

export const UPDATE_APPOINTMENT = gql`
  mutation UpdateAppointment($id: ID!, $input: UpdateAppointmentInput!) {
    updateAppointment(id: $id, input: $input) {
      id
      appointment_date
      appointment_time
      status
      isHomeService
      isPaymentComplete
      notes
      updatedAt
    }
  }
`

export const CANCEL_APPOINTMENT = gql`
  mutation CancelAppointment($id: ID!, $input: CancelAppointmentInput!) {
    cancelAppointment(id: $id, input: $input) {
      id
      status
      cancellation_reason
      updatedAt
    }
  }
`


